import { useEffect, type ReactNode } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useWindowSession } from '../../app/WindowSession';
import './companion.css';

export function ChatGate({children}:{children:ReactNode}) {
  const c=useWindowSession().companion;
  const navigate=useNavigate(), location=useLocation();
  const restored=c?.restoredSearch;
  useEffect(()=>{
    if(restored===null || restored===undefined || !c)return;
    const path=c.native?'/chat-app':'/dialogs';
    if(location.pathname!==path || location.search!==restored)void navigate(path+restored,{replace:true});
    else c.clearRestoredSearch();
  },[c,restored,location.pathname,location.search,navigate]);
  // Mount the conversation only after its URL and transferred drafts agree.
  if(restored!==null && restored!==undefined)return <section className="chat-companion-wait" role="status">Восстанавливаем переписку…</section>;
  if(c && (c.native?!c.allowed:c.phase==='native'||c.phase==='returning'))return <section className="chat-companion-wait" role="status"><strong>{c.native?'Подключаем отдельный чат…':'Чат открыт в отдельном приложении'}</strong><p>{c.error||c.notice||'Сообщения и звонки остаются в одном окне.'}</p>{!c.native&&<p>Чтобы вернуть чат, нажмите правой кнопкой на серый значок чата в верхней полосе.</p>}</section>;
  return children;
}
